import React from 'react';
import { func, oneOf, bool } from 'prop-types';
import SelectionCards from './SelectionCards';
import { CoborrowerConsent } from '../../../baui-ui/components';
import { INDIVIDUAL, JOINT, LOAN_TYPE_CONTENTS } from './constants';

import './LoanTypeSelectionCards.scss';

/**
 * getLoanTypeCardContent
 * build styled content to display in cards
 *
 * @param {Object} props contains image, text and description
 * @param {Object} props.image image to display on the card
 * @param {Object} props.text title of the card
 * @returns {JSX.Element}
 */
const getLoanTypeCardContent = ({ image, text }) => (
  <div className="LoanTypeSelectionCards">
    <div className="LoanTypeSelectionCards-imgWithText">
      <img src={image.src} alt={image.alt} />
      <span className="LoanTypeSelectionCards-imgText">{text}</span>
    </div>
  </div>
);

const loanTypes = {
  name: 'loanType',
  items: [
    {
      content: getLoanTypeCardContent(LOAN_TYPE_CONTENTS[INDIVIDUAL]),
      value: INDIVIDUAL,
      id: INDIVIDUAL,
    },
    {
      content: getLoanTypeCardContent(LOAN_TYPE_CONTENTS[JOINT]),
      value: JOINT,
      id: JOINT,
    },
  ],
};

/**
 * LoanTypeSelectionCards
 * Selection cards for different type of loans
 * @component
 * @param {Object} props contains loanType, and onClick
 * @param {Object} props.loanType loan type card to select
 * @param {Object} props.onClick click handler to update selection
 * @returns {JSX.Element}
 */
const LoanTypeSelectionCards = ({ loanType, onClick }) => (
  <>
    <SelectionCards {...loanTypes} loanType={loanType} onClick={onClick}></SelectionCards>
    <div className="LoanTypeSelectionCards-description">{LOAN_TYPE_CONTENTS[loanType].description}</div>
    {loanType === 'joint' && (
      <div className="ConsentNotice">
        <CoborrowerConsent />
      </div>
    )}
  </>
);

LoanTypeSelectionCards.propTypes = {
  loanType: oneOf(['individual', 'joint']),
  onClick: func.isRequired,
};

LoanTypeSelectionCards.defaultProps = {
  loanType: INDIVIDUAL,
};

export default LoanTypeSelectionCards;

